module.exports = __webpack_public_path__ + "img/Выписка-из-реестра-лицензий-по-состоянию-на-16-08-01.08.2022г._Page_3.df6268a5.jpg";